import React from 'react';
import { FileText, HardHat, Factory, ClipboardList, PencilRuler } from 'lucide-react';
import { AUDIENCE } from '../mock';

const ICON_MAP = { FileText, HardHat, Factory, ClipboardList, PencilRuler };

export default function Audience() {
  return (
    <section className="bg-[#f5f5f7] py-24 md:py-28 border-t border-slate-200/70">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="text-[12px] font-semibold tracking-[0.25em] text-[#0f1a2b]/60 mb-4">DLA KOGO PRACUJĘ</div>
        <h2 className="font-heading font-extrabold text-[40px] md:text-[54px] leading-[1.05] tracking-tight text-[#0f1a2b]">
          Dla kogo pracuję?
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {AUDIENCE.map((a) => {
            const Icon = ICON_MAP[a.icon];
            return (
              <div key={a.title} className="rounded-2xl bg-white border border-slate-200 p-7 hover-lift">
                <div className="h-11 w-11 rounded-lg bg-[#132a44] flex items-center justify-center mb-6">
                  <Icon className="h-5 w-5 text-[#f5c518]" />
                </div>
                <h3 className="font-heading font-bold text-[19px] tracking-tight text-[#0f1a2b]">{a.title}</h3>
                <p className="mt-3 text-[14px] leading-relaxed text-[#0f1a2b]/70">{a.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
